const fleetGridletContentLu = {
  bindings: {
    fleet: '<',
    dataLoading: '<',
    onTrainSelect: '&',
    filter: '<',
  },
  templateUrl: '/modules/gridlets/dashboard/fleet-gridlet-content-lu/fleet-gridlet-content-lu.html',
  controller: 'FleetGridletContentLuController',
};

angular
  .module('dashboardGridletDirectives')
  .component('fleetGridletContentLu', fleetGridletContentLu);
